import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import SwitchField from "../../../components/Fields/SwitchField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    projectTypeId: number
}

interface ProjectTypeWorkflowRole {
    projectTypeId: number
    functionalRoleId: number
    required: boolean
}

const AddProjectTypeWorkflowRolePopup: React.FC<Props> = ({ show, onHide, projectTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const workflowRoles = useSelectListOptions('api/v1/selectlist/WorkflowRoles', '-- Select workflow role');

    const [formData, setFormData] = useState<ProjectTypeWorkflowRole|undefined>({
        projectTypeId: projectTypeId,
        functionalRoleId: 0,
        required: false
    });

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/ProjectTypeWorkflowRoles/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && onHide)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'functionalRoleId', label: 'Workflow role', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'required', label: 'Required', labelSize: 4},
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Add workflow role'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('functionalRoleId')} options={workflowRoles} />
                <SwitchField {...getFieldProps('required')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Create' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProjectTypeWorkflowRolePopup;